export default {
  TRANSACTION_CALCULATOR_TOUR: 'TRANSACTION_CALCULATOR_TOUR',
  TRANSACTION_SUMMARY_TOUR: 'TRANSACTION_SUMMARY_TOUR',
  BENEFICIARY_LIST_TOUR: 'BENEFICIARY_LIST_TOUR',
  BENEFICIARY_SELECT_TOUR: 'BENEFICIARY_SELECT_TOUR',
  BENEFICIARY_FORM_TOUR: 'BENEFICIARY_FORM_TOUR'
}
